import * as React from "react";
import "./RocketSpinnerComponent.css";
import { SvgIcon } from "./SvgIcon";
import { Rocket02 } from "@icons";

export interface RocketSpinnerComponentProps {}

export const RocketSpinnerComponent = (props: RocketSpinnerComponentProps) => (
    <div className="rocket-spinner">
        <SvgIcon className="rocket-spinner-svg" svg={Rocket02} />
    </div>
);
